import React from "react";
import SearchHeader from "@presto-components/Headers/SearchHeader";

export default function SearchableScreen(props) {
  return <SearchHeader {...props} />;
}
